export function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

export const convertToCountrySpecificId = (oldId, country) => {
  const countryMultipliers = {
    'MY': 1000,
    'SG': 1100,
    'PH': 1200,
    'ID': 1300
  };
  
  const baseMultiplier = Math.floor(countryMultipliers[country] / 100);
  
  if (oldId < 100) {
    // Parent category: 1 -> 1000
    return oldId * 1000 + (baseMultiplier - 10) * 100;
  } else {
    // Child category: 101 -> 1001
    const parentId = Math.floor(oldId / 100);
    const childOffset = oldId % 100;
    return parentId * 1000 + (baseMultiplier - 10) * 100 + childOffset;
  }
};
